import __ from 'languages/index';
import { useParams } from 'react-router-dom';
import WalletList from './wallet_list';
import WalletDetail from './wallet_detail';

export default function Wallet() {
  let { wallet_unit } = useParams();

  if (wallet_unit) return <WalletDetail />;
  else return <WalletList />;
}
